import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatAccordion } from "@angular/material/expansion";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { el } from "date-fns/locale";
import { correctFloat } from "highcharts";
import moment from "moment-timezone";
import { FirestoreService } from "src/app/services/firestore.service";
import { UtilService } from "src/app/services/util.service";
import * as dropDownData from "../../../../assets/json/commonDropdownValues.json"
import Swal from "sweetalert2";

@Component({
  selector: "app-expansion",
  templateUrl: "./expansion.component.html",
  styleUrls: ["./expansion.component.scss"],
})
export class ExpansionComponent implements OnInit {
  defectForm: FormGroup = new FormGroup({
    left: new FormControl("", [Validators.required]),
    top: new FormControl("", [Validators.required]),
    part: new FormControl("", [Validators.required]),
    location: new FormControl("", [Validators.required]),
    defects: new FormControl({}, [Validators.required]),
  });
  locationList = [];
  shiftList = dropDownData['default'].shiftList
  defectsList = [
    { name: "Run Down", code: "RD" },
    { name: "Less Coverage", code: "LC" },
    { name: "Dust", code: "DT" },
    { name: "Lint", code: "LN" },
    { name: "Crater/Scissing", code: "CR" },
    { name: "Popping", code: "POP" },
    { name: "Dent", code: "DNT" },
    { name: "Bump", code: "BMP" },
    { name: "Scratch", code: "SCR" },
    { name: "Burr/Spatter", code: "BR" },
    { name: "Grinding Mark", code: "GM" },
    { name: "Underbody Application", code: "UBA" },
    { name: "Underbody Overspray", code: "UBO" },
    { name: "Sealant Application ", code: "SA" },
    { name: "Ecxcess Sealant", code: "ES" },
    { name: "Floor Trim Grommet availability", code: "FTG" },
    { name: "Melting Sheet application", code: "MS" },
  ];
  modalDropdownList = [
    { text: "Pro 1000 Series", modelId: "pro_1000" },
    { text: "Pro 2000 Series", modelId: "pro_2000" },
    { text: "Pro 3000 Series", modelId: "pro_3000" },
    { text: "Pro 5000 Series", modelId: "pro_5000" },
    { text: "Pro 6000 Series", modelId: "pro_6000" },
    { text: "Pro 8000 Series", modelId: "pro_8000" },
  ];
  selectedLocation = "";
  checklist;
  selectedDefects: any;
  clickedChecklist: any;
  defectsCount: {};
  edit: boolean;
  selectedPart: any = {key : "part"};
  selectedIndexForEditing: any;
  selectedPartImage: string;
  selectedCabinType: any;
  partsList: string[];
  @Input("checklist")
  set in(val) {
    this.checklist = val;
  }
  parts = {
    condor:{
      "Front lid": [
        "Front lid top area LHS",
        "Front lid top area RHS",
        "Front lid lower area LHS",
        "Front lid lower area RHS"
      ],
      "Bumper": [
        "Bumper top area LHS",
        "Bumper top area RHS",
        "Bumper lower area LHS",
        "Bumper lower area RHS",
      ],
      "LH Door outer": [
        "LH Door outer lower area",
        "LH Door outer middle area",
        "LH Door outer top area",
        "LH Door outer glass frame area",
        "LH door outer key cylinder area",
        "LH door outer side lamp area"
      ],
      "LH Door inner": [
        "LH Door inner lower area",
        "LH Door inner hinge area",
        "LH Door inner top glass frame area",
        "LH Door inner latch area",
      ],
      "RH Door outer": [
        "RH Door outer lower area",
        "RH Door outer middle area",
        "RH Door outer top area",
        "RH Door outer glass frame area",
        "RH door outer key cylinder area",
        "RH door outer side lamp area"
      ],
      "RH Door inner": [
        "RH Door inner lower area",
        "RH Door inner hinge area",
        "RH Door inner top glass frame area",
        "RH Door inner latch area",
      ],
      "Rear panel": [
        "LH Rear panel lower area",
        "LH Rear panel middle area",
        "LH Rear panel top area ",
        "RH Rear panel lower area",
        "RH Rear panel middle area",
        "RH Rear panel top area",
      ],
      "LH Rear panel": [
        "LH Rear panel lower area",
        "LH Rear panel middle area",
        "LH Rear panel top area",
      ],
      "LH Door fender sash inner": [
        "LH Door inner fender sash area",
        "LH Door inner door hinge area",
        "LH Door inner striker area",
      ],
      "RH Rear panel": [
        "RH Rear panel lower area",
        "RH Rear panel middle area",
        "RH Rear panel top area",
      ],
      "RH Door fender sash inner": [
        "RH Door inner fender sash area",
        "RH Door inner door hinge area",
        "RH Door inner striker area",
      ],
      "LH Corner panel": [
        "LH corner panel outer area",
        "LH corner panle inner bracket area",
        "LH corner panel top edge area",
      ],
      "RH Corner panel": [
        "RH corner panel outer area",
        "RH corner panle inner bracket area",
        "RH corner panel top edge area",
      ],
    },
    ld:{
      "Front panel": [
        "Front panel top area LHS",
        "Front panel top area RHS",
        "Front panel center area",
        "Front panel lower area LHS",
        "Front panel lower area RHS",
      ],
      Bumper: [
        "Bumper top area LHS",
        "Bumper top area RHS",
        "Bumper lower area LHS",
        "Bumper lower area RHS",
      ],
      "Front facia": [
        "Front facia top area LHS",
        "Front facia top area RHS",
        "Front facia lower area LHS",
        "Front facia lower area RHS",
      ],
      "LH Door outer": [
        "LH Door outer lower area",
        "LH Door outer middle area",
        "LH Door outer top area",
        "LH Door outer glass frame area",
        "LH door outer key cylinder area",
      ],
      "LH Door inner": [
        "LH Door inner lower area",
        "LH Door inner hinge area",
        "LH Door inner top glass frame area",
        "LH Door inner latch area",
      ],
      "RH Door outer": [
        "RH Door outer lower area",
        "RH Door outer middle area",
        "RH Door outer top area",
        "RH Door outer glass frame area",
        "RH door outer key cylinder area",
      ],
      "RH Door inner": [
        "RH Door inner lower area",
        "RH Door inner hinge area",
        "RH Door inner top glass frame area",
        "RH Door inner latch area",
      ],
      "Rear panel": [
        "LH Rear panel lower area",
        "LH Rear panel middle area",
        "LH Rear panel top area ",
        "RH Rear panel lower area",
        "RH Rear panel middle area",
        "RH Rear panel top area",
      ],
      "LH Rear panel": [
        "LH Rear panel lower area",
        "LH Rear panel middle area",
        "LH Rear panel top area",
        "LH Rear panel snorkle bracket area",
      ],
      "LH Door fender sash inner": [
        "LH Door inner fender sash area",
        "LH Door inner door hinge area",
        "LH Door inner striker area",
      ],
      "RH Rear panel": [
        "RH Rear panel lower area",
        "RH Rear panel middle area",
        "RH Rear panel top area",
        "RH Rear panel snorkle bracket area",
      ],
      "RH Door fender sash inner": [
        "RH Door inner fender sash area",
        "RH Door inner door hinge area",
        "RH Door inner striker area",
      ],
      "LH Corner panel": [
        "LH corner panel outer area",
        "LH corner panle inner bracket area",
        "LH corner panel top edge area",
      ],
      "RH Corner panel": [
        "RH corner panel outer area",
        "RH corner panle inner bracket area",
        "RH corner panel top edge area",
      ],
    },
    hd:{
      "Front panel": [
        "Front panel top area LHS",
        "Front panel top area RHS",
        "Front panel center area",
        "Front panel lower area LHS",
        "Front panel lower area RHS",
      ],
      "Bumper": [
        "Bumper top area LHS",
        "Bumper top area RHS",
        "Bumper lower area LHS",
        "Bumper lower area RHS",
      ],
      "LH Door outer": [
        "LH Door outer lower area",
        "LH Door outer middle area",
        "LH Door outer top area",
        "LH Door outer glass frame area",
        "LH door outer key cylinder area",
      ],
      "LH Door inner": [
        "LH Door inner lower area",
        "LH Door inner hinge area",
        "LH Door inner top glass frame area",
        "LH Door inner latch area",
      ],
      "RH Door outer": [
        "RH Door outer lower area",
        "RH Door outer middle area",
        "RH Door outer top area",
        "RH Door outer glass frame area",
        "RH door outer key cylinder area",
      ],
      "RH Door inner": [
        "RH Door inner lower area",
        "RH Door inner hinge area",
        "RH Door inner top glass frame area",
        "RH Door inner latch area",
      ],
      "Rear panel": [
        "LH Rear panel lower area",
        "LH Rear panel middle area",
        "LH Rear panel top area ",
        "RH Rear panel lower area",
        "RH Rear panel middle area",
        "RH Rear panel top area",
      ],
      "LH Rear panel": [
        "LH Rear panel lower area",
        "LH Rear panel middle area",
        "LH Rear panel top area",
        "LH Rear panel snorkle bracket area",
      ],
      "LH Door fender sash inner": [
        "LH Door inner fender sash area",
        "LH Door inner door hinge area",
        "LH Door inner striker area",
      ],
      "RH Rear panel": [
        "RH Rear panel lower area",
        "RH Rear panel middle area",
        "RH Rear panel top area",
        "RH Rear panel snorkle bracket area",
      ],
      "RH Door fender sash inner": [
        "RH Door inner fender sash area",
        "RH Door inner door hinge area",
        "RH Door inner striker area",
      ],
      "LH Corner panel": [
        "LH corner panel outer area",
        "LH corner panle inner bracket area",
        "LH corner panel top edge area",
      ],
      "RH Corner panel": [
        "RH corner panel outer area",
        "RH corner panle inner bracket area",
        "RH corner panel top edge area",
      ],
    },
    "2000":{
      "Bumper": [
        "Bumper top area LHS",
        "Bumper top area RHS",
        "Bumper lower area LHS",
        "Bumper lower area RHS",
      ],
      "LH Door outer": [
        "LH Door outer lower area",
        "LH Door outer middle area",
        "LH Door outer top area",
        "LH Door outer glass frame area",
        "LH door outer key cylinder area",
        "LH door outer side lamp area"
      ],
      "LH Door inner": [
        "LH Door inner lower area",
        "LH Door inner hinge area",
        "LH Door inner top glass frame area",
        "LH Door inner latch area",
      ],
      "RH Door outer": [
        "RH Door outer lower area",
        "RH Door outer middle area",
        "RH Door outer top area",
        "RH Door outer glass frame area",
        "RH door outer key cylinder area",
        "LH door outer side lamp area"
      ],
      "RH Door inner": [
        "RH Door inner lower area",
        "RH Door inner hinge area",
        "RH Door inner top glass frame area",
        "RH Door inner latch area",
      ],
      "Rear panel": [
        "LH Rear panel lower area",
        "LH Rear panel middle area",
        "LH Rear panel top area ",
        "RH Rear panel lower area",
        "RH Rear panel middle area",
        "RH Rear panel top area",
      ],
      "LH Rear panel": [
        "LH Rear panel lower area",
        "LH Rear panel middle area",
        "LH Rear panel top area",
      ],
      "LH Door fender sash inner": [
        "LH Door inner fender sash area",
        "LH Door inner door hinge area",
        "LH Door inner striker area",
      ],
      "RH Rear panel": [
        "RH Rear panel lower area",
        "RH Rear panel middle area",
        "RH Rear panel top area",
      ],
      "RH Door fender sash inner": [
        "RH Door inner fender sash area",
        "RH Door inner door hinge area",
        "RH Door inner striker area",
      ],
    },
    "8000":{
      "LH Door outer": [
        "LH Door outer lower area",
        "LH Door outer middle area",
        "LH Door outer top area",
        "LH Door outer glass frame area",
        "LH door outer key cylinder area",
        "LH door outer side lamp area"
      ],
      "LH Door inner": [
        "LH Door inner lower area",
        "LH Door inner hinge area",
        "LH Door inner top glass frame area",
        "LH Door inner latch area",
      ],
      "RH Door outer": [
        "RH Door outer lower area",
        "RH Door outer middle area",
        "RH Door outer top area",
        "RH Door outer glass frame area",
        "RH door outer key cylinder area",
        "LH door outer side lamp area"
      ],
      "RH Door inner": [
        "RH Door inner lower area",
        "RH Door inner hinge area",
        "RH Door inner top glass frame area",
        "RH Door inner latch area",
      ],
      "Rear panel": [
        "LH Rear panel lower area",
        "LH Rear panel middle area",
        "LH Rear panel top area ",
        "RH Rear panel lower area",
        "RH Rear panel middle area",
        "RH Rear panel top area",
      ],
      "LH Rear panel": [
        "LH Rear panel lower area",
        "LH Rear panel middle area",
        "LH Rear panel top area",
      ],
      "LH Door fender sash inner": [
        "LH Door inner fender sash area",
        "LH Door inner door hinge area",
        "LH Door inner striker area",
      ],
      "RH Rear panel": [
        "RH Rear panel lower area",
        "RH Rear panel middle area",
        "RH Rear panel top area",
      ],
      "RH Door fender sash inner": [
        "RH Door inner fender sash area",
        "RH Door inner door hinge area",
        "RH Door inner striker area",
      ],
    }
  };
  pictorialData = {
    "CED DFT & Adhesion": [
      {
        grid: "col-md-12",
        img_src: "../../../../assets/images/ced_dft.png",
        data: [
          {
            data_id: 1,
            top: "-341px",
            left: "71px",
            Shift_A: "",
            Shift_B: "",
            Shift_C: "",
          },
          { data_id: 2, top: "-365px", left: "170px" },
          { data_id: 3, top: "-372px", left: "265px" },
          { data_id: 4, top: "-467px", left: "298px" },
          { data_id: 5, top: "-370px", left: "418px" },
          { data_id: 6, top: "-370px", left: "574px" },
          { data_id: 7, top: "-370px", left: "723px" },
          { data_id: 8, top: "-330px", left: "1066px" },
          { data_id: 9, top: "-358px", left: "975px" },
          { data_id: 10, top: "-364px", left: "883px" },
          { data_id: 11, top: "-465px", left: "844px" },
          { data_id: 12, top: "-161px", left: "422px" },
          { data_id: 13, top: "-138px", left: "256px" },
          { data_id: 14, top: "-163px", left: "92px" },
          { data_id: 15, top: "-145px", left: "712px" },
          { data_id: 16, top: "-144px", left: "883px" },
          { data_id: 17, top: "-146px", left: "1071px" },
        ],
      },
    ],
    "Top Coat DFT & Gloss": [
      {
        grid: "col-md-12",
        img_src: "../../../../assets/images/top_coat.png",
        data: [
          {
            data_id: 1,
            top: "-316px",
            left: "65px",
            Shift_A: "",
            Shift_B: "",
            Shift_C: "",
          },
          { data_id: 2, top: "-351px", left: "160px" },
          { data_id: 3, top: "-372px", left: "255px" },
          { data_id: 4, top: "-478px", left: "255px" },
          { data_id: 5, top: "-350px", left: "408px" },
          { data_id: 6, top: "-350px", left: "540px" },
          { data_id: 7, top: "-350px", left: "674px" },
          { data_id: 8, top: "-316px", left: "1051px" },
          { data_id: 9, top: "-351px", left: "965px" },
          { data_id: 10, top: "-351px", left: "856px" },
          { data_id: 11, top: "-457px", left: "839px" },
          { data_id: 12, top: "-155px", left: "257px" },
          { data_id: 13, top: "-149px", left: "153px" },
          { data_id: 14, top: "-131px", left: "48px" },
          { data_id: 15, top: "-165px", left: "410px" },
          { data_id: 16, top: "-146px", left: "534px" },
          { data_id: 17, top: "-119px", left: "625px" },
          { data_id: 18, top: "-169px", left: "884px" },
          { data_id: 19, top: "-166px", left: "1110px" },
        ],
      },
    ],
    "UBS DFT": [
      {
        grid: "col-md-12",
        img_src: "../../../../assets/images/ubs_dft.png",
        data: [
          {
            data_id: 1,
            top: "-170px",
            left: "780px",
            Shift_A: "",
            Shift_B: "",
            Shift_C: "",
          },
          { data_id: 2, top: "-316px", left: "785px" },
          { data_id: 3, top: "-466px", left: "784px" },
          { data_id: 4, top: "-470px", left: "271px" },
          { data_id: 5, top: "-320px", left: "271px" },
          { data_id: 6, top: "-166px", left: "271px" },
        ],
      },
    ],
  };
  @Input() checklistType: string = "today";
  @Output() editCheckList = new EventEmitter();
  @ViewChild(MatAccordion) accordion: MatAccordion;
  ackData = ["Normal", "Abnormal", "Standby"];
  frequencyDropdown: any = {
    data: ["Daily", "Weekly", "Monthly"],
    selected: {},
  };
  criticalityDropdown: any = ["Low", "Medium", "Moderate", "High"];
  selectedAck = "";
  activeField: any = {};
  datatable: any = {
    header: [],
    rowData: [],
    inputData: [],
  };
  dropdownCategory: any = {
    Criticality: {
      value: this.criticalityDropdown,
      type: "arrayString",
    },
    Acknowledge: {
      value: this.ackData,
      type: "arrayString",
    },
  };
  maintenanceID = undefined;
  constructor(
    private fs: FirestoreService,
    private util: UtilService,
    private modalService: NgbModal
  ) {}
  ngOnInit(): void {
    this.initiateValues();
  }
  initiateValues() {
    if (
      this.checklist.maintenanceData &&
      this.checklist.maintenanceData.length > 0
    ) {
      this.maintenanceID = this.checklist.maintenanceData[0].id;
      this.checklist.check_points =
        this.checklist.maintenanceData[0].check_points;
      this.checklist.metaData = this.checklist.maintenanceData[0].metaData;
      this.checklist.check_points.forEach((c, index) => {
        this.activeField[index] = true;
      });
      if (this.checklist.view_type && this.checklist.view_type == "pictorial") {
        this.checklist.pictorialData =
          this.checklist.maintenanceData[0].pictorialData;
      }
      if (
        this.checklist.view_type &&
        this.checklist.view_type == "defect_sheet"
      ) {
        this.checklist.defectData =
          this.checklist.maintenanceData[0].defectData;
      }
    } else {
      if (this.checklist.view_type && this.checklist.view_type == "pictorial") {
        this.checklist.pictorialData =
          this.pictorialData[this.checklist.checklist_name];
      }
    }
    if (this.checklist.headerColumns) {
      this.checklist.headerColumns.forEach((column: any) => {
        if (column.columncomesunder == "CheckPoints") {
          this.datatable.header.push(column);
        } else if (column.columncomesunder == "Maintenance") {
          this.datatable.inputData.push(column);
        }
      });
    }
  }
validateMetaData(metaData){
  let count = 0;
  if(metaData && metaData.length){
  for(let i = 0; i < metaData.length; i++){
    if(!metaData[i].value || metaData[i].value == '' ){
      this.util.showSnakbarMessage(
        "error",
        `Please fill all mandatory fields (*).` ,
        "end",
        "top"
      )
      count = 1
      break;
    }
  }
  }
  if(count == 0){
    return true
  }else{
    return false
  }
}
submitChecklist(e) {
    // if(e.view_type =='defect_sheet'){
    //   if(localStorage.getItem(e.checklist_name)){
    //     e.defectData[0].data = JSON.parse(localStorage.getItem(e.checklist_name))
    //     e.isDefected = true
    //     localStorage.removeItem(e.checklist_name)
    //   }else{
    //     Swal.fire({
    //       title: 'Are you sure no defects?',
    //       input:'checkbox',
    //       inputPlaceholder:'Claiming as no Defects',
    //       showCancelButton: true,
    //       confirmButtonText: 'Submit',
    //     }).then((result) => {
    //       if (result.isConfirmed) {
    //         e.isDefected = false
    //       }
    //   })
    // }
    // }
   
    if(this.validateMetaData(e.metaData)){
      if (e.view_type == "defect_sheet") {
        if (e.defectData[0].data.length) {
          e.isDefected = true;
          e.totalDefects = 0
            e.defectData[0].data.forEach((d) =>{
              if(Object.keys(d.defects).length){
                for(let key in d.defects){
                  e.totalDefects += d.defects[key].count
                }
              }
            })
          this.submit(e);
        } else {
          Swal.fire({
            title: "Are you sure no defects?",
            showCancelButton: true,
            confirmButtonText: "Yes/Submit",
          }).then((result) => {
            if (result.isConfirmed) {
              e.isDefected = false;
              e.totalDefects = 0
              this.submit(e);
            }
          });
        }
      } else {
        this.submit(e);
      }
    }
  }
  submit(e) {
    let acknowledgeCount = 0;
    let checkPointHeader = 0;
    let filterHeaderDropdown = e.headerColumns.filter((headerData) => {
      return headerData.columnType == "Dropdown";
    });
    if(e.checklist_name == 'ED Line Sheet' || e.checklist_name == 'PT Check Sheet' || e.checklist_name == 'Spray Booth Sheet'){
      e.isKpiDone = false
    }
    if (filterHeaderDropdown.length > 0) {
      e.check_points.forEach((checkPointData) => {
        filterHeaderDropdown.forEach((headerData) => {
          if (
            headerData.dropdownCategory &&
            headerData.dropdownCategory.label &&
            headerData.dropdownCategory.label == "Acknowledge"
          ) {
            if (!checkPointData[headerData.columnId]) {
              checkPointData[headerData.columnId] =
                headerData.dropdownCategory.value[0];
            }
          }
        });
      });
    }

    let fixedFields = this.datatable.header.length;
    if (e.check_points.length > 0) {
      e.check_points.forEach((element: any) => {
        if (
          Object.keys(element).length == 1 &&
          Object.keys(element).indexOf("header") > -1
        ) {
          checkPointHeader++;
        }
        if (
          Object.keys(element).length != 1 &&
          Object.keys(element).indexOf("header") == -1 &&
          fixedFields < Object.keys(element).length
        ) {
          acknowledgeCount++;
        }
      });
    }
    let ackAvg =
      (acknowledgeCount / (e.check_points.length - checkPointHeader)) * 100;
    e.percentage = parseFloat(ackAvg.toFixed(2));
    let maintenanceData =
      this.checklistType == "today"
        ? moment().toDate()
        : moment().subtract(1, "day").toDate();
    if (this.maintenanceID == undefined) {
      e["checklistid"] = e.id;
      e["maintenanceDate"] = maintenanceData;
      e["email"] = localStorage.getItem("email");
      e["type"] = "checklist";
      this.fs.fireStoreDocInsert("MAINTENANCE", e).subscribe((data: any) => {
        if (data.status == "success") {
          if(e.defectData){
            e.defectData[0].data = [];
          }
          this.util.showSnakbarMessage(
            "success",
            "Checklist saved successfully",
            "end",
            "top"
          );
        }
      });
    } else {
      delete e.maintenanceData;
      e["email"] = localStorage.getItem("email");
      this.fs
        .fireStoreDocUpdate("MAINTENANCE", this.maintenanceID, e)
        .subscribe((data: any) => {
          if (data.status == "success") {
            this.util.showSnakbarMessage(
              "success",
              "Checklist saved successfully",
              "end",
              "top"
            );
          }
        });
    }
  }
  editChecklist(checklist) {
    this.editCheckList.emit(checklist);
  }
  
  toggleFunc(i: any) {
    this.activeField[i] = !this.activeField[i];
    // this.activeField = i == this.activeField ? null : i
  }
  deleteChecklist(data) {
    Swal.fire({
      title: "Do you want to delete this Checklist?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: `Delete`,
      denyButtonText: `Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.fs.fireStoreDocDelete("CHECKLIST", data.id).subscribe((d: any) => {
          if (d.status == "success") {
            this.util.showSnakbarMessage(
              "success",
              "Checklist deleted successfully!",
              "end",
              "top"
            );
            this.editCheckList.emit("delete");
          } else {
            this.util.showSnakbarMessage(
              "error",
              "Checklist deletion failed",
              "end",
              "top"
            );
          }
        });
      } else if (result.isDenied) {
      }
    });
  }

  checkAction(action) {
    let access = this.util.getAccessForAction(
      "Maintenance",
      "Checklist",
      action
    );
    return access;
  }
  checkDataType(data) {
    let type = typeof data;
    if (type == "string") {
      return data;
    } else {
      if (data) {
        if (data.value == "Range (Min - Max)") {
          return `${data.min} - ${data.max} ${data.unit}`;
        } else if (data.value == "Lesserthan (<)") {
          return `< ${data.thresh_value} ${data.unit}`;
        } else if (data.value == "Greaterthan (>)") {
          return `> ${data.thresh_value} ${data.unit}`;
        } else if (data.value == "Equals (=)") {
          return `Equal to ${data.thresh_value} ${data.unit}`;
        } else if (data.value == "Min") {
          return `Min ${data.thresh_value} ${data.unit}`;
        } else if (data.value == "Max") {
          return `Max ${data.thresh_value} ${data.unit}`;
        } else if (data.value == "Text") {
          return `${data.thresh_value}`;
        }
        return data.value;
      } else {
        return "NA";
      }
    }
  }
  // coaridante setting
  onAreaEdit(coordinate: ImageMapCoordinate): ImageMapCoordinate {
    return coordinate;
  }
  onAreaClick(coordinate?: any) {
    // if(this.type=="config" && !coordinate.assetcode) {
    //   this.onClick.emit(coordinate);
    // }
    // if(this.type=="normal" && coordinate.assetcode) {
    //   this.onClick.emit(coordinate);
    // }
  }
  getCoordinateStyle(coordinate: ImageMapCoordinate): object {
    return {
      top: `${coordinate.y}px`,
      left: `${coordinate.x}px`,
    };
  }
  popupOpen(content, templateName?, type?, data?, index?,cabinType?) {
    let modalObj = {};
    if (templateName == "defect") {
      modalObj = { size: "lg" };
    }

    this.modalService.open(content, modalObj).result.then(() => {});
    if (type == "edit") {
      this.selectedIndexForEditing = index;
      this.selectedCabinType = cabinType
      this.edit = true;
      this.partsList = Object.keys(this.parts[cabinType])
      this.selectedPart = data.part;
      this.selectedPartImage  = `../../../../assets/images/cabinParts/${cabinType}_${data.part}.png`
      this.defectForm.get("part").setValue(data.part);
      this.defectForm.get("left").setValue(data.left);
      this.defectForm.get("top").setValue(data.top);
      this.defectForm.get("location").setValue(data.location);
      this.defectsCount = data.defects;
      this.selectedLocation = this.defectForm.get("location").value;
      this.defectForm.get("defects").setValue(this.defectsCount);
      this.selectedDefects = [];
      this.defectsList.forEach((d) => {
        if (data.defects[d.code]) {
          this.selectedDefects.push(d);
        }
      });
    } else {
      this.selectedIndexForEditing = null;
      this.edit = false;
      this.defectsCount = {};
      this.selectedDefects = [];
    }
  }
  getClick(coordinate: any, checklist: any, content, divId) {
    let div = document.getElementById(divId).getBoundingClientRect();
    let img = document
      .getElementById(checklist.checklist_name)
      .getBoundingClientRect();
    let imgX = img.left - div.left;
    let imgY = img.top - div.top;
    this.clickedChecklist = checklist;
    this.selectedCabinType = this.clickedChecklist.cabinType
    this.partsList = Object.keys(this.parts[this.selectedCabinType])
    this.defectForm.reset();
    this.defectForm.get("top").setValue(`${coordinate.offsetY + imgY}px`);
    this.defectForm.get("left").setValue(`${coordinate.offsetX + imgX}px`);
    this.popupOpen(content, "defect", "add");
  }
  changeParts(e) {
    this.selectedPart = e
    this.locationList = this.parts[this.clickedChecklist.cabinType][e];
    this.selectedPartImage  = `../../../../assets/images/cabinParts/${this.clickedChecklist.cabinType}_${e}.png`
    this.defectForm.get("part").setValue(e);
  }
  changeLocation(event) {
    this.selectedLocation = event;
    this.defectForm.get("location").setValue(event);
  }
  selectDefects(e) {
    this.selectedDefects = e;
    let tempCounts = { ...this.defectsCount };
    this.defectsCount = {};
    this.selectedDefects.forEach((d) => {
      if (tempCounts[d.code]) {
        this.defectsCount[d.code] = tempCounts[d.code];
      } else {
        this.defectsCount[d.code] = { name: d.name, count: 1 };
      }
    });
    this.defectForm.get("defects").setValue(this.defectsCount);
  }
  addDefect(form) {
    if (form.valid) {
      // if(localStorage.getItem(this.clickedChecklist)){
      // let data =  JSON.parse(localStorage.getItem(this.clickedChecklist))
      // data.push(form.value);
      // localStorage.setItem(this.clickedChecklist,JSON.stringify(data));
      // }else{
      //   let data = [form.value];
      //   localStorage.setItem(this.clickedChecklist,JSON.stringify(data));
      // }
      if (this.edit) {
        form.value.defects = this.defectsCount;
        this.clickedChecklist.defectData[0].data[this.selectedIndexForEditing] =
          form.value;
        this.modalService.dismissAll();
      } else {
        this.clickedChecklist.defectData[0].data.push(form.value);
        this.defectsCount = {};
        this.selectedPart = {}
        this.selectedPartImage = ""
        this.modalService.dismissAll();
      }
    }
  }
  getNewChecklist(checklist) {
    if (localStorage.getItem(checklist.checklist_name)) {
      Swal.fire({
        title: "Please Submit Existance Check sheet",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Submit`,
        denyButtonText: `Cancel`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.submitChecklist(checklist);
        } else if (result.isDenied) {
        }
      });
    }
  }
  formatDefects(defects, type) {
    if (type == "onImage") {
      let codes = "";
      if (Object.keys(defects).length) {
        for (let key in defects) {
          codes += key + ", ";
        }
      }
      return codes;
    } else {
      let codes = "";
      if (Object.keys(defects).length) {
        for (let key in defects) {
          codes += `${key} - ${defects[key].count}, `;
        }
      }
      return codes;
    }
  }
  checkObjLen(ob) {
    return Object.keys(ob).length;
  }
  deleteDefect(defects, i) {
    Swal.fire({
      title: "Do you want to delete this Defect?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: `Delete`,
      denyButtonText: `Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        defects.splice(i, 1);
      }
    });
  }
  updateMetaData(value,checklist,data,key){
    data.value = value
    if(key =='model'){
      checklist[key] = value.modelId;
    }else{
      checklist[key] = value;
    }

  }
}
export class ImageMapCoordinate {
  x: number = 0;
  y: number = 0;
  name?: string;

  constructor(init?: Partial<ImageMapCoordinate>) {
    Object.assign(this, init);
  }
}
